// node modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import orderBy from 'lodash/orderBy';

// app modules: components
import Image from 'components/Image';
import Link from 'components/Link';

// app modules: props
import RecommendationsProps from 'components/Recommendations/RecommendationsProps';

// app modules: services
import assets from 'services/assets';
import route from 'services/route';

// assets
import CssRecommendations from './Recommendations.scss';

class Recommendations extends Component {
  static propTypes = {
    recommendations: PropTypes.arrayOf(RecommendationsProps.recommendation).isRequired,
  };

  render() {
    const { recommendations } = this.props;

    return orderBy(
      recommendations,
      recommendation => (recommendation.comment && recommendation.comment.length) || 0,
      'desc',
    ).map((recommendation, recommendationIndex) => {
      const key = `recommendation-${recommendationIndex}`;
      const { comment, person } = recommendation;
      const personName = `${person.first_name} ${person.last_name}`;

      return (
        <div className="recommendation" key={key}>
          <div className="recommendation__avatar">
            <Link to={route.person(person.id, person.is_author)}>
              <Image
                image={assets.avatarUrl(person.avatar_name, {
                  resize: 'fit-in',
                  width: 45,
                  height: 45,
                })}
                shape="circle"
                height={45}
                width={45}
              />
            </Link>
          </div>

          <section className="recommendation__person">
            <h3 className="recommendation__person__heading">
              <Link to={route.person(person.id, person.is_author)}>{personName}</Link>
            </h3>
            <p className="recommendation__person__title">{person.title}</p>
            <p className="recommendation__person__comment">{comment}</p>
          </section>
        </div>
      );
    });
  }
}

export default withStyles(CssRecommendations)(Recommendations);
